import React from 'react';
import { useTranslation } from 'react-i18next';
import EmdbButtom from "../../../EmdbButtom";
//CSS
import  styles from './VTSelectDeparture.module.less';

function Departure({departure, selectedDeparture, availability, getTotalPax, setDeparture}) {
  return (
    <EmdbButtom
      label={departure.hour}
      onClick={()=> getTotalPax() <= availability[departure.id] ? setDeparture(departure.id) : null}
      selected={selectedDeparture == departure.id ? true: false}
      disabled={getTotalPax() <= availability[departure.id] ? false: true}
    />
  );
}

function VTSelectDeparture({departures, selectedDate, selectedDeparture, availability, getTotalPax, setDeparture}) {

  const [t] = useTranslation("vtform");
  const weekday = selectedDate.getDay() === 0 ? 7 : selectedDate.getDay();

  //Buscamos cuantas salidas hay para el dia seleccionado
  const departureIDs = departures.flatMap( departure => {
    //Salidas Semanales
    if (departure.type === 2) {
      if (departure.weekdays.indexOf(weekday) !== -1) return departure.id;
      else return [];
    }
  });

  //Información de la salida
  //Si solo hay una salida ese día la selecionamos. Si no enseñamos las salidas porque necesitamos accion manual
  let listDepartures;
  if (departureIDs.length==1){
    setDeparture(departureIDs[0]);
    listDepartures=null;
  }else{
    listDepartures = departures.map( departure =>{
      if (departureIDs.indexOf(departure.id) != -1)
      return (
        <Departure
          key={departure.id}
          departure={departure}
          selectedDeparture={selectedDeparture}
          availability={availability}
          getTotalPax={getTotalPax}
          setDeparture={setDeparture}
        />
      )
    });
  }

  if (!listDepartures) return null;

  return (
    <div className={styles.selectdeparture}>
      <div className={styles.title}>{t('vtselectdeparture.Seleccione una salida')}</div>
      <div className={styles.departures}>
        {listDepartures}
      </div>
    </div>
  );

}

export default VTSelectDeparture;
